import {
    fetchGet,
    fetchPost,
    fetchPut,
    jsonToQueryParam,
} from "./CommonServiceUtils";

import Constants from "Constants";

const BASE_URL = `${Constants.BASE_URL}loyaltyservice/`;


const getAttributes = (queryObj) => {
    return fetchGet(`${BASE_URL}attributes?${jsonToQueryParam(queryObj)}`);
};

const createAttribute = (payload) => {
    return fetchPost(`${BASE_URL}attributes`, payload);
};

const updateAttribute = (id, payload) => {
    return fetchPut(`${BASE_URL}attributes/${id}`, payload);
};




export {
    getAttributes,
    createAttribute,
    updateAttribute,
};
